import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  return (
    <section className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-icon">🚫</div>
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-description">
          Sorry, the page you're looking for doesn't exist or has been moved. 
          Let's get you back on track!
        </p>
        
        <div className="not-found-actions">
          <Link to="/" className="not-found-btn not-found-btn-primary">
            🏠 Back to Home
          </Link>
          <Link to="/shop" className="not-found-btn not-found-btn-outline">
            🛍️ Continue Shopping
          </Link>
        </div>
        
        <div className="not-found-suggestions">
          <h3>Popular Pages</h3>
          <div className="not-found-links">
            <Link to="/shop" className="not-found-link">Shop</Link>
            <Link to="/brands" className="not-found-link">Brands</Link>
            <Link to="/offers" className="not-found-link">Offers</Link>
            <Link to="/contact" className="not-found-link">Contact</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
